"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoteImageGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useShapeToBorderRadiusAlias = require("@cbhq/cds-common/hooks/useShapeToBorderRadiusAlias");
var _useAvatarSize = require("@cbhq/cds-common/media/useAvatarSize");
var _getRemoteImageGroupOverlapSpacing = require("@cbhq/cds-common/utils/getRemoteImageGroupOverlapSpacing");
var _Box = require("../layout/Box");
var _tokens = require("../tokens");
var _useTypographyStyles = require("../typography/useTypographyStyles");
const _excluded = ["children", "size", "max", "shape", "testID"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const RemoteImageGroup = _ref => {
  let children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 4 : _ref$max,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'circle' : _ref$shape,
    testID = _ref.testID,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const arrayChildren = _react.Children.toArray(children);
  const borderRadius = (0, _useShapeToBorderRadiusAlias.useShapeToBorderRadiusAlias)(shape);
  const sizeIsString = typeof size === 'string';
  const sizeIsNumber = typeof size === 'number';
  const overlapSpacing = (0, _getRemoteImageGroupOverlapSpacing.getRemoteImageGroupOverlapSpacing)(size);

  // obtain avatar size
  // set the avatar size to m, if no size was set
  const letterSizeOfAvatar = sizeIsString ? size : 'm';
  const avatarSize = (0, _useAvatarSize.useAvatarSize)(letterSizeOfAvatar);
  const excessSize = sizeIsNumber ? size : avatarSize;

  // Has more children than max can handle
  const excess = arrayChildren.length - max;

  /**
   * Reversing the children is a great way to avoid using zIndex
   * to overlap the avatars
   */
  const reverseChildren = arrayChildren.reverse().splice(0, max);
  const showExcess = excess > 0;

  // Dynamically calculate font size based on size of remote image
  // so smaller excess image gets a smaller text, and larger excess
  // image gets a larger text
  const typographyStyles = (0, _useTypographyStyles.useTypographyStyles)('legal');
  const fontSizeStyle = (0, _react.useMemo)(() => {
    return {
      fontSize: (sizeIsNumber ? size : avatarSize) * 0.4,
      color: _tokens.palette.foreground,
      marginTop: 'auto',
      marginBottom: 'auto'
    };
  }, [sizeIsNumber, size, avatarSize]);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    alignItems: "center",
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "flex-end",
    testID: testID
  }, props), showExcess && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    alignItems: "center",
    background: "backgroundOverlay",
    borderRadius: borderRadius,
    height: excessSize,
    justifyContent: "center",
    offsetStart: overlapSpacing,
    width: excessSize
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: typographyStyles,
    "data-testid": `${testID}-excess-text`,
    style: fontSizeStyle
  }, "+", excess)), _react.Children.map(reverseChildren, (child, index) => {
    const isFirstRemoteImage = index === 0;
    if ( /*#__PURE__*/(0, _react.isValidElement)(child)) {
      let overrideChildProps = {};
      if (sizeIsString) {
        overrideChildProps = Object.assign({}, overrideChildProps, {
          size
        });
      } else if (sizeIsNumber) {
        // yes, we don't want to carry the
        // size from the above statement. Its either
        // use this size or the size above
        overrideChildProps = Object.assign({}, overrideChildProps, {
          width: size,
          height: size
        });
      } else {
        // No size was set, carry the default
        // avatarSize of m to child
        overrideChildProps = Object.assign({}, overrideChildProps, {
          width: avatarSize,
          height: avatarSize
        });
      }

      // The shape of its child shall take precedence
      if (shape && child.props.shape === undefined) {
        overrideChildProps = Object.assign({}, overrideChildProps, {
          shape
        });
      }
      const clonedChild = /*#__PURE__*/_react.default.cloneElement(child, overrideChildProps);
      return /*#__PURE__*/_react.default.createElement(_Box.Box, {
        offsetEnd: isFirstRemoteImage ? 0 : overlapSpacing,
        testID: `${testID}-inner-box-${index}`,
        zIndex: index
      }, clonedChild);
    }
    return null;
  }));
};
exports.RemoteImageGroup = RemoteImageGroup;